module.exports = __webpack_public_path__ + "static/media/tx.b89bad00.png";